/**
 * Utilidad para construir URLs de archivos protegidos con token JWT.
 * Las etiquetas <img> del navegador no pueden enviar headers Authorization,
 * por lo que el backend acepta el token vía query param ?token=...
 *
 * Security note: today this embeds the full session JWT in the query string
 * (logs/history/Referer risk). Prefer short-lived scoped file tokens when available
 * (avatar/sign already use scoped JWT on the API).
 */

/**
 * Construye la URL completa de un archivo protegido.
 * @param relativePath Ruta relativa dentro de uploads (ej: "images/profiles/abc.jpg")
 * @param token JWT token (opcional, si no se provee se lee de localStorage)
 * @returns URL completa lista para usar en src de <img>
 */
export function getFileUrl(relativePath: string | undefined, token?: string): string {
  if (!relativePath) return '';

  const jwt = token || localStorage.getItem('token') || '';
  if (!jwt) return '';

  // Asegurar que no haya doble slash
  const cleanPath = relativePath.startsWith('/') ? relativePath.slice(1) : relativePath;

  return `/api/files/${cleanPath}?token=${encodeURIComponent(jwt)}`;
}
